// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81cf3b82","455":"caf8b93b","977":"7d8facff"}[chunkId] + ".chunk.js";
};